export default {
    setCategoryList(state, data) {
        state.list = data;
    },
    setCategoryValidation(state, data) {
        state.validation = data;
    },
}